import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/img/secure.png'


const _withScopeId = n => (_pushScopeId("data-v-5092eb54"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = {
  key: 0,
  class: "title"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "" }, [
  /*#__PURE__*/_createTextVNode(" Pagamento in modalità test, inserire "),
  /*#__PURE__*/_createElementVNode("b", null, "4242 4242 4242 4242"),
  /*#__PURE__*/_createTextVNode(" come numero carta."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Per gli altri campi va bene qualunque dato. ")
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "cardBlocks" }
const _hoisted_6 = {
  key: 0,
  class: "text-center mt-4"
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "cardContainer" }
const _hoisted_9 = { class: "cardholder" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user" }, null, -1))
const _hoisted_11 = { ref: "cardelement" }
const _hoisted_12 = {
  ref: "carderrors",
  class: "mt-2 text-danger",
  role: "alert"
}
const _hoisted_13 = {
  key: 0,
  class: "saveCardForm mt-3"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Salva carta per i pagamenti futuri", -1))
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://stripe.com",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "300",
    class: "mt-5",
    src: _imports_0
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mini_spinner = _resolveComponent("mini-spinner")!
  const _component_stripe_saved_cards = _resolveComponent("stripe-saved-cards")!
  const _component_toggler = _resolveComponent("toggler")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isTestMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (!_ctx.cards)
      ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.cards && _ctx.cards.length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass(["cardBlock", { active: _ctx.showNewCard }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setShowNewCard()))
            }, " Nuova carta di credito ", 2),
            _createElementVNode("div", {
              class: _normalizeClass(["cardBlock", { active: !_ctx.showNewCard }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showNewCard = false))
            }, " Carte di credito salvate ", 2)
          ]),
          (_ctx.cards.length > 0 && !_ctx.showNewCard)
            ? (_openBlock(), _createBlock(_component_stripe_saved_cards, {
                key: 0,
                cards: _ctx.cards,
                modelValue: _ctx.selectedCard,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedCard) = $event))
              }, null, 8, ["cards", "modelValue"]))
            : _createCommentVNode("", true),
          (_ctx.paying)
            ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 1 }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_ctx.selectedCard)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-block btn-blue fs-22",
                        disabled: !!!_ctx.selectedCard,
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.pay && _ctx.pay(...args)))
                      }, "Paga", 8, _hoisted_7)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.cards && _ctx.cards.length == 0 || _ctx.showNewCard && !!!_ctx.selectedCard)
      ? (_openBlock(), _createElementBlock("form", {
          key: 3,
          class: "paymentForm",
          ref: "paymentform",
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.pay && _ctx.pay(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "Intestatario carta",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.cardholderName) = $event))
              }, null, 512), [
                [_vModelText, _ctx.cardholderName]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, null, 512),
            _createElementVNode("div", _hoisted_12, null, 512)
          ]),
          (_ctx.paying)
            ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (!_ctx.isTestMode)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _hoisted_14,
                      _createVNode(_component_toggler, {
                        class: "ml-2",
                        modelValue: _ctx.saveCard,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.saveCard) = $event))
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  ref: "submit",
                  type: "submit",
                  class: "mt-4 btn btn-pay btn-primary",
                  disabled: !_ctx.canPay
                }, "Procedi con il pagamento", 8, _hoisted_15)
              ], 64))
        ], 544))
      : _createCommentVNode("", true),
    _hoisted_16
  ]))
}